import { makeStyles } from "@fluentui/react-components";

export const useMobileStyles = makeStyles({
    button: {
        textAlign: "left",
        justifyContent: "flex-start",
        margin: "0",
        height: "30px", // Set a consistent height for all buttons
        display: "flex",
        alignItems: "center"
    },
    accordion: {
        width: "100%"
    },
    accordionHeader: {
        padding: 0,
        margin: 0,
        width: "100%",
        
        "& button": {
            paddingLeft: "6px",
            textAlign: "left",
            justifyContent: "flex-start",
            width: "100%",
            height: "30px", // Ensure the height matches the other buttons
            display: "flex",
            alignItems: "center",
            marginRight: "auto"
        }
    },
    link: {
        display: "block",
        marginTop: "2px",
        color: "black",
        textDecoration: "none"
    }
});